import { render } from "./detail.vue?vue&type=template&id=8157cbc8&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=8157cbc8&lang=less&scoped=true"

import exportComponent from "E:\\self\\loyi\\pro-DT-member-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8157cbc8"]])

export default __exports__